import { Box, Button } from 'grommet';
import { Trash } from 'grommet-icons';

export type LineItemDeleteProps = {
  /** What's deleted, for the button's accessible name */
  name: string;
  onClick: () => void;
};

/**
 * A line item's delete: a quiet trash icon in a 40px column, shown when the row (marked with the
 * `line-item` class) is hovered or has focus, and always on touch screens (globals.css). It deletes
 * straight away, with an Undo toast instead of a confirmation (useUndoableDelete).
 */
export const LineItemDelete = ({ name, onClick }: LineItemDeleteProps) => (
  <Box width="40px" flex={false} align="center" className="line-item-delete">
    <Button
      plain
      icon={<Trash size="16px" color="text-secondary" />}
      a11yTitle={`Delete ${name}`}
      onClick={(event) => {
        event.stopPropagation();
        onClick();
      }}
    />
  </Box>
);
